export const categories = [
  {
    id: 'compliance',
    name: '合规平台识别',
    slug: 'compliance',
    description: '了解如何识别合法合规的成人内容平台，掌握平台资质验证方法',
    icon: 'ri-shield-check-line',
    articleCount: 6,
  },
  {
    id: 'privacy',
    name: '隐私保护',
    slug: 'privacy',
    description: '全面了解个人隐私保护策略，防止信息泄露与数据滥用',
    icon: 'ri-lock-line',
    articleCount: 5,
  },
  {
    id: 'safe-access',
    name: '安全访问技巧',
    slug: 'safe-access',
    description: '掌握安全浏览技巧与工具使用，降低访问过程中的安全风险',
    icon: 'ri-key-2-line',
    articleCount: 6,
  },
  {
    id: 'legal-risks',
    name: '法律风险提示',
    slug: 'legal-risks',
    description: '深入了解各地法律法规，明确合法边界，规避潜在法律风险',
    icon: 'ri-scales-3-line',
    articleCount: 5,
  },
  {
    id: 'anti-fraud',
    name: '防诈骗指南',
    slug: 'anti-fraud',
    description: '识别常见诈骗手法，学习防范技巧，保护财产安全',
    icon: 'ri-alert-line',
    articleCount: 7,
  },
  {
    id: 'virus-protection',
    name: '病毒防护',
    slug: 'virus-protection',
    description: '了解恶意软件传播途径，掌握设备安全防护与病毒查杀方法',
    icon: 'ri-virus-line',
    articleCount: 5,
  },
];